import { render, staticRenderFns } from "./IntroPanel.vue?vue&type=template&id=bc7a7f36&scoped=true&"
import script from "./IntroPanel.vue?vue&type=script&lang=js&"
export * from "./IntroPanel.vue?vue&type=script&lang=js&"
import style0 from "./IntroPanel.vue?vue&type=style&index=0&id=bc7a7f36&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc7a7f36",
  null
  
)

export default component.exports